import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import dayjs from 'dayjs';
import { StyledFreeFormDeliveryForm } from './style';
import { TextArea } from 'ui/TextArea';
import { FreeFormDeliveryFormProps } from '../../../../types/ListingData';
import { DatePicker } from 'ui/DatePicker';

export const FreeFormDeliveryForm = ({
  formData,
  isEditing = false,
  onFormDataChange,
}: FreeFormDeliveryFormProps) => {
  const intl = useIntl();
  const form = useFormInstance();

  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        free_form_description: formData.free_form_description,
        contract_start_date: formData.contract_start_date
          ? dayjs(formData.contract_start_date)
          : undefined,
        contract_end_date: formData.contract_end_date
          ? dayjs(formData.contract_end_date)
          : undefined,
      });
    }
  }, [formData, form]);

  const handleFormChange = () => {
    const currentFormData = form.getFieldsValue(true);
    const dataWithId = {
      ...currentFormData,
      ...(formData?.id && { id: formData.id }),
    };
    onFormDataChange?.(dataWithId);
  };

  return (
    <StyledFreeFormDeliveryForm>
      <div className="form-section">
        <div className="form-row">
          <div className="form-field">
            <DatePicker
              name="contract_start_date"
              label={intl.formatMessage({
                id: 'listings.form.start_date',
              })}
              onChange={handleFormChange}
            />
          </div>
          <div className="form-field">
            <DatePicker
              name="contract_end_date"
              label={intl.formatMessage({
                id: 'listings.form.end_date',
              })}
              onChange={handleFormChange}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const startDate = getFieldValue('contract_start_date');
                    if (!value || !startDate) {
                      return Promise.resolve();
                    }
                    if (value.isBefore(startDate) || value.isSame(startDate)) {
                      return Promise.reject(
                        new Error(
                          intl.formatMessage({
                            id: 'validation.end_date_after_start',
                          })
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            />
          </div>
        </div>
        <TextArea
          areaClassName="free-form-description"
          name="free_form_description"
          placeholder={intl.formatMessage({
            id: 'listings.form.delivery_description',
          })}
          maxLength={2000}
          onChange={handleFormChange}
        />
      </div>
    </StyledFreeFormDeliveryForm>
  );
};
